import { extendTheme } from '@chakra-ui/react'

import { theme as baseTheme, withThemeColors } from '@saas-ui-pro/react'
import { theme as glassTheme } from '@saas-ui/theme-glass'

import semanticTokens from './foundations/semantic-tokens'
import { components } from './components'

// import colorScheme from './color-schemes/galaxy'
// import colorScheme from './color-schemes/earth'

export const theme = extendTheme(
  {
    semanticTokens,
    components,
  },
  glassTheme,
  baseTheme,
)
